import React from 'react';

interface TrackingTabProps {
  trackingItems: any[];
  onItemSelect?: (item: any) => void;
}

const TrackingTab: React.FC<TrackingTabProps> = ({ trackingItems, onItemSelect }) => {
  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'In Progress':
        return 'ti ti-clock text-warning';
      case 'Completed':
        return 'ti ti-circle-check text-success';
      case 'Pending':
        return 'ti ti-hourglass text-info';
      default:
        return 'ti ti-circle text-secondary';
    }
  };

  if (trackingItems.length === 0) {
    return (
      <div className="text-center py-5">
        <div className="d-flex flex-column align-items-center">
          <i className="ti ti-route fs-48 text-muted mb-3"></i>
          <h5 className="text-muted">No Items to Track</h5>
          <p className="text-muted">No workflow items are currently being tracked.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="tracking-list">
      {trackingItems.map((item) => (
        <div key={item.id} className="card mb-3">
          <div className="card-body">
            <div className="d-flex align-items-start justify-content-between mb-3">
              <div className="d-flex align-items-start">
                <div className="me-3">
                  <i className={getStatusIcon(item.status)} style={{ fontSize: '24px' }}></i>
                </div>
                <div>
                  <h6 className="mb-1 fw-medium">
                    <button 
                      className="btn btn-link p-0 text-start text-decoration-none fw-medium text-dark"
                      onClick={() => onItemSelect && onItemSelect(item)}
                    >
                      {item.subject}
                    </button>
                  </h6>
                  <p className="text-muted mb-2 small">From: {item.from}</p>
                </div>
              </div>
              <small className="text-muted">{item.sentDate}</small>
            </div>
            
            <div className="row">
              <div className="col-md-6">
                <div className="mb-2">
                  <span className="text-muted small">Status:</span>
                  <span className={`badge ms-2 ${item.status === 'In Progress' ? 'bg-warning' : item.status === 'Completed' ? 'bg-success' : 'bg-info'}`}>
                    {item.status}
                  </span>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-2">
                  <span className="text-muted small">Priority:</span>
                  <span className={`badge ms-2 ${item.priority === 'High' ? 'bg-danger' : item.priority === 'Medium' ? 'bg-warning' : 'bg-success'}`}>
                    {item.priority}
                  </span>
                </div>
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-between mt-3">
              <div className="progress" style={{ height: '6px', width: '60%' }}>
                <div 
                  className={`progress-bar ${item.status === 'Completed' ? 'bg-success' : 'bg-primary'}`}
                  style={{ width: item.status === 'Completed' ? '100%' : '60%' }}
                ></div>
              </div>
              <div className="d-flex gap-2">
                <button 
                  className="btn btn-sm btn-outline-primary"
                  title="View Timeline"
                >
                  <i className="ti ti-timeline"></i>
                </button>
                <button 
                  className="btn btn-sm btn-outline-info"
                  title="Track Status"
                >
                  <i className="ti ti-search"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TrackingTab;